module.exports = __webpack_public_path__ + "graphic.png?31d21f6e3e8ceac36d187436e130f94f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Solution/HugeData/graphic.png
// module id = 184
// module chunks = 0